<template>
    <div class="custom-file" :class="inputClass">
        <input type="file" class="custom-file-input" v-bind:id="id" v-bind:name="name">
        <label class="custom-file-label" v-bind:for="id">
            {{$t(placeholder)}}
        </label>
    </div>
</template>

<script>
export default {
  name: 'FileComponent',
  props: ['id', 'value', 'name', 'placeholder', 'type', 'inputClass', 'checkboxes']
}
</script>



// WEBPACK FOOTER //
// src/components/core/form/inputs/FileComponent.vue